module.exports = __webpack_public_path__ + "static/media/logo-mosaic-life-inverse-no-tm.6cf76f86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-mosaic-life-inverse-no-tm.svg
// module id = 450
// module chunks = 0